import * as React from "react";


const AppContext = React.createContext(null);
AppContext.displayName = "AppContext";

export const AppContextProvider = AppContext.Provider;
export const useAppContext = () => React.useContext(AppContext);
